export default "__VITE_ASSET__7c6251ee__"